import { gql } from 'Utils/apolloClient'
import InstallmentDataFragment from '../Queries/installmentDataFragment'

const installmentReceiptMutation = gql`
  mutation InstallmentPrintReceipt($installmentId: ID!) {
    installmentPrintReceipt(input: {installmentId: $installmentId}){
      installment {
        ...installmentData
      }
    }
  }

  ${InstallmentDataFragment}`

export default installmentReceiptMutation
